module.exports = __webpack_public_path__ + "img/movieTheater-3.51d1cd7e.jpg";